/**
 * Entry point for development and production PWA builds.
 */
import 'regenerator-runtime/runtime';
import '../tailwind.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import { initSentry } from './sentry';



// Runtime configuration that can be injected at container startup
const getBuildTimeEnv = key => {
  if (typeof process === 'undefined' || !process.env) {
    return undefined;
  }
  return process.env[key];
};

const getRuntimeConfig = () => {
  // Check for runtime environment variables (injected by container)
  const runtimeEnv = window.RUNTIME_ENV || {};
  
  // Check for config endpoint (for multi-tenancy)
  const configEndpoint = runtimeEnv.CONFIG_ENDPOINT;
  
  return {
    BACKEND_URL: runtimeEnv.BACKEND_URL || getBuildTimeEnv('BACKEND_URL'),
    CONFIG_ENDPOINT: configEndpoint,
    INFERENCE_MEASUREMENT_ALLOWLIST:
      runtimeEnv.INFERENCE_MEASUREMENT_ALLOWLIST ??
      getBuildTimeEnv('INFERENCE_MEASUREMENT_ALLOWLIST'),
    BS_EXAM_ANALYTICS:
      runtimeEnv.BS_EXAM_ANALYTICS ?? getBuildTimeEnv('BS_EXAM_ANALYTICS'),
    ENABLE_MOROCCO_MAP:
      runtimeEnv.ENABLE_MOROCCO_MAP ?? getBuildTimeEnv('ENABLE_MOROCCO_MAP') ?? 'true',
    // Injected per deployment by the nginx entrypoint. It was being dropped:
    // this function *replaces* window.RUNTIME_ENV, so anything not named here
    // is lost even though runtime-config.js set it.
    CLIENT_NAME: runtimeEnv.CLIENT_NAME || getBuildTimeEnv('CLIENT_NAME'),
    SENTRY_DSN: runtimeEnv.SENTRY_DSN || getBuildTimeEnv('SENTRY_DSN'),
    SENTRY_ENVIRONMENT:
      runtimeEnv.SENTRY_ENVIRONMENT || getBuildTimeEnv('SENTRY_ENVIRONMENT'),
    // Add other runtime configurable variables here
  };
};

// Initialize runtime config
window.RUNTIME_ENV = getRuntimeConfig();

// Error reporting, before anything else runs - a crash during App construction
// is exactly the kind we cannot see any other way. No-op without a DSN.
initSentry({
  dsn: window.RUNTIME_ENV.SENTRY_DSN,
  environment: window.RUNTIME_ENV.SENTRY_ENVIRONMENT,
  release: getBuildTimeEnv('VERSION_NUMBER'),
  tenant: window.RUNTIME_ENV.CLIENT_NAME,
});





const appProps = {};

/** Create App */
const app = React.createElement(App, appProps, null);
/** Render */
ReactDOM.render(app, document.getElementById('root'));

